import { HotelSearchSummaryPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-summary/hotel-search-summary.types";
import { dateFormat, daysBetweenDates } from "@website/utils/date-format";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
import toNumber from "lodash-es/toNumber";
import { useRouter } from "next/router";

const parseQueryToNumber = (query?: string) => {
  const convertedNumber = toNumber(query);
  return Number.isNaN(convertedNumber) ? 0 : convertedNumber;
};

export const useHotelSearchSummary = (
  properties: HotelSearchSummaryPropertiesType
) => {
  const router = useRouter();
  const { searchType, cityTitle, dateFrom, dateTo, adults, children, noRooms } =
    properties;

  return {
    searchType,
    cityTitle,
    dateFrom: dateFormat(dateFrom, {
      locale: router.locale,
      template: "dd MMMM"
    }) as string,
    dateTo: dateFormat(dateTo, {
      locale: router.locale,
      template: "dd MMMM"
    }) as string,
    passengersCount:
      !isFilled(adults) && !isFilled(children)
        ? undefined
        : numberConvert(
            parseQueryToNumber(adults) + parseQueryToNumber(children),
            {
              locale: router.locale
            }
          ),
    roomsCount: isFilled(noRooms)
      ? numberConvert(parseQueryToNumber(noRooms), {
          locale: router.locale
        })
      : undefined,
    nightCount: daysBetweenDates(dateFrom, dateTo)
  };
};
